import React from 'react';

export const RecentRecordsSection = ({
    activeCardioHistoryPageData,
    deleteCardioRecord,
    activeHistoryPageData,
    deleteRecord,
    supplementHistoryData,
    deleteSupplements
}) => {
    const supplementDateParse = timestamp => {
        const suppDateTime = new Date(timestamp);
        return `${suppDateTime.getFullYear()}-${suppDateTime.getMonth()+1}-${suppDateTime.getDate()}`;
    };

    return (
        <section className='ml-4 mr-4'>
            <div className="flex items-center gap-2 mb-4 px-1">
                <span className="bg-indigo-500 text-white text-[10px] font-black px-2 py-0.5 rounded-md tracking-wider">03</span>
                <h3 className="text-lg font-black text-slate-800 tracking-tight">최근 기록</h3>
            </div>
            <div className="space-y-4">
                
                {/* 1) 유산소 최근 기록 */}
                <details className="group bg-white rounded-2xl border border-slate-100 shadow-sm transition-all open:pb-4">
                    <summary className="flex items-center justify-between p-4 text-sm font-bold text-slate-700 hover:bg-slate-50 cursor-pointer list-none">
                        <span className="flex items-center gap-2"><span className="material-icons-round text-teal-500">history</span>유산소</span>
                        <span className="material-icons-round text-slate-400 group-open:rotate-180 transition-transform">expand_more</span>
                    </summary>
                    <div className="mt-2 px-4 space-y-4 animate-fadeIn">
                        {activeCardioHistoryPageData && activeCardioHistoryPageData.length > 0 ? activeCardioHistoryPageData?.map((workout) => (
                            <div key={workout.id} className="card p-5 bg-white rounded-2xl shadow-sm border border-slate-100 relative overflow-hidden group">
                                <div className="absolute top-0 left-0 w-1 h-full bg-teal-500"></div>
                                <div className="flex justify-between items-start mb-4">
                                    <div>
                                        <h4 className="font-black text-slate-800 text-base">{workout.name}</h4>
                                        <p className="text-[11px] font-bold text-slate-400 mt-0.5">{workout.date}</p>
                                    </div>
                                    <button onClick={() => deleteCardioRecord(workout.id)} className="p-1.5 text-slate-300 hover:text-rose-500">
                                        <span className="material-icons-round text-[18px]">delete_outline</span>
                                    </button>
                                </div>
                                <div className="space-y-2">
                                    {workout?.sets?.map((set, idx) => (
                                        <div key={idx} className="flex flex-wrap items-center gap-1.5 bg-slate-50 p-2 rounded-xl border border-slate-100">
                                            <span className="text-[10px] font-black text-slate-400 mr-1">{idx + 1}세트</span>
                                            {set.phase && <span className="bg-white text-slate-600 text-[11px] font-bold px-2 py-1 rounded-md border border-slate-100">🏃 {set.phase}</span>}
                                            {set.time && <span className="bg-white text-slate-600 text-[11px] font-bold px-2 py-1 rounded-md border border-slate-100">⏳ {set.time}분</span>}
                                            {set.distance && <span className="bg-white text-slate-600 text-[11px] font-bold px-2 py-1 rounded-md border border-slate-100">🏃 거리 {set.distance}km</span>}
                                            {set.pace && <span className="bg-white text-slate-600 text-[11px] font-bold px-2 py-1 rounded-md border border-slate-100">🏃 페이스 {set.pace}km</span>}
                                            {set.speed && <span className="bg-white text-slate-600 text-[11px] font-bold px-2 py-1 rounded-md border border-slate-100">🏃 {set.speed}km/h</span>}
                                            {set.reps && <span className="bg-white text-slate-600 text-[11px] font-bold px-2 py-1 rounded-md border border-slate-100">⊕ {set.reps} 회</span>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )) : <div className="text-center py-6 text-sm font-bold text-slate-400 border-2 border-dashed border-slate-200 rounded-xl">기록이 없습니다.</div>}
                    </div>
                </details>

                {/* 2) 헬스 최근 기록 (난이도 표시 추가) */}
                <details className="group bg-white rounded-2xl border border-slate-100 shadow-sm transition-all open:pb-4">
                    <summary className="flex items-center justify-between p-4 text-sm font-bold text-slate-700 hover:bg-slate-50 cursor-pointer list-none">
                        <span className="flex items-center gap-2"><span className="material-icons-round text-indigo-500">history</span>헬스</span>
                        <span className="material-icons-round text-slate-400 group-open:rotate-180 transition-transform">expand_more</span>
                    </summary>
                    <div className="mt-2 px-4 space-y-4 animate-fadeIn">
                        {activeHistoryPageData && activeHistoryPageData.length > 0 ? activeHistoryPageData?.map((workout) => (
                            <div key={workout.id} className="card p-5 bg-white rounded-2xl shadow-sm border border-slate-100 relative overflow-hidden group">
                                <div className="absolute top-0 left-0 w-1 h-full bg-indigo-500"></div>
                                <div className="flex justify-between items-start mb-4">
                                    <div>
                                        <h4 className="font-black text-slate-800 text-base">{workout.name}</h4>
                                        <p className="text-[11px] font-bold text-slate-400 mt-0.5">{workout.date}</p>
                                    </div>
                                    <button onClick={() => deleteRecord(workout.id)} className="p-1.5 text-slate-300 hover:text-rose-500">
                                        <span className="material-icons-round text-[18px]">delete_outline</span>
                                    </button>
                                </div>
                                <div className="flex flex-wrap gap-2">
                                    {workout.sets?.map((set, idx) => (
                                        <span key={idx} className="flex items-center gap-1.5 bg-slate-50 text-slate-600 text-[11px] font-black px-2.5 py-1.5 rounded-lg border border-slate-100">
                                            <span>{set.weight}kg × {set.reps}</span>
                                            
                                            {/* DB에서 불러온 난이도 뱃지 렌더링 */}
                                            {set.difficulty && (
                                                <span className={`px-1.5 py-0.5 rounded text-[10px] ${
                                                    set.difficulty === '쉬움' ? 'bg-emerald-100 text-emerald-600' :
                                                    set.difficulty === '어려움' ? 'bg-rose-100 text-rose-600' :
                                                    'bg-indigo-100 text-indigo-600'
                                                }`}>
                                                    {set.difficulty}
                                                </span>
                                            )}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )) : <div className="text-center py-6 text-sm font-bold text-slate-400 border-2 border-dashed border-slate-200 rounded-xl">기록이 없습니다.</div>}
                    </div>
                </details>

                {/* 3) 보조제 최근 기록 */}
                <details className="group bg-white rounded-2xl border border-slate-100 shadow-sm transition-all open:pb-4">
                    <summary className="flex items-center justify-between p-4 text-sm font-bold text-slate-700 hover:bg-slate-50 cursor-pointer list-none">
                        <span className="flex items-center gap-2"><span className="material-icons-round text-emerald-500">history</span>보조제</span>
                        <span className="material-icons-round text-slate-400 group-open:rotate-180 transition-transform">expand_more</span>
                    </summary>
                    <div className="mt-2 px-4 space-y-4 animate-fadeIn">
                        {supplementHistoryData && supplementHistoryData.length > 0 ? supplementHistoryData?.map((supp, idx) =>(
                            <div key={idx} className="card p-4 bg-white rounded-3xl shadow-sm border border-slate-100 relative overflow-hidden">
                                <div className="absolute top-0 left-0 w-1 h-full bg-emerald-500"></div>
                                <div className="mb-2"><p className="text-[11px] font-bold text-slate-400">{supplementDateParse(supp.date)}</p></div>
                                <p className="text-sm font-medium text-slate-700 whitespace-pre-wrap leading-relaxed">{supp.text}</p>
                                <div className='flex justify-end items-center mt-2'>
                                    <button onClick={() => deleteSupplements(supp.id)} className="p-1.5 text-slate-300 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors">
                                        <span className="material-icons-round text-[18px]">delete_outline</span>
                                    </button>
                                </div>
                            </div>
                        )) : (
                            <div className="text-center py-6 text-sm font-bold text-slate-400 border-2 border-dashed border-slate-200 rounded-xl">기록이 없습니다.</div>
                        )}
                    </div>
                </details>

            </div>
        </section>
    );
};